$(document).ready(function(){

 // Hide Header on on scroll down
var prevScrollpos = window.pageYOffset;

window.onscroll = function() {
var currentScrollPos = window.pageYOffset;

    
  if (prevScrollpos > currentScrollPos) {
     document.getElementById("logoholder").style.top = "0";
       // document.getElementById("navmenu").style.top = "0";

      
  } else {
    document.getElementById("logoholder").style.top = "-140px";
    // document.getElementById("navmenu").style.top = "-80px"; 
      
  }

    
   if (prevScrollpos <= 0) {
       document.getElementById("logoholder").style.top = "0";
       // document.getElementById("navmenu").style.top = "0";     
    }

  prevScrollpos = currentScrollPos;
} 

//Change Logo Colour
var logonav = document.getElementById("header-nav-logo");
//$(logonav).find('.fill-primary').addClass('fill-secondary');
// $(logonav).find('.fill-primary').removeClass('fill-primary');

    
// Hide Header on on scroll down
var prevScrollpos = window.pageYOffset;
     $(".openmenu").click(function(){
          $("body").addClass('deactivatescroll');
         document.getElementById("logoholder").style.top = "-140px";
         $('#navmenu').addClass('openmenu');
         $('#navmenu').removeClass('closedmenu');
         
         
   });
    
     $(".closemenu").click(function(){
         document.getElementById("logoholder").style.top = "-0px";
          $('#navmenu').removeClass('openmenu');
         $('#navmenu').addClass('closedmenu');
          $("body").removeClass('deactivatescroll');
          document.getElementById("logoholder").style.top = "-0px";
    });

    var width = $(window).width();
       $(window).on('resize', function() {
         if ($(this).width() != width) {
           document.getElementById("logoholder").style.top = "-0px";
                 $('#navmenu').removeClass('openmenu');
                $('#navmenu').addClass('closedmenu');
                 $("body").removeClass('deactivatescroll');
                 document.getElementById("logoholder").style.top = "-0px";
         }
       });
    
    

  $( ".childWrapper" ).mouseover(function() {
    $(this).find('.bgImage').stop().animate({width:'100%', height: '100%'});
    $(this).find('svg').stop().animate({width:'220'});
  }).mouseout(function() {
    $(this).find('.bgImage').stop().animate({width:'110%', height: '110%'});
      $(this).find('svg').stop().animate({width:'0'});
  });
    
    $('#popupvideo').on('hidden.bs.modal', function () {
          $('.myVideoClass').each(function(){
            $(this).stopVideo();
         });
     
});
    

          $('.fade-delay-1').each(function(){
            $(this).addClass('visible');
        });
    
            $('.fade-delay-2').each(function(){
            $(this).addClass('visible');
        });
    
            $('.fade-delay-3').each(function(){
            $(this).addClass('visible');
        });
    
        $('.fade-delay-4').each(function(){
            $(this).addClass('visible');
        });
    
    /* BANNER */
    
 });


var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];
        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap ease-in">'+this.txt+'</span>';

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
              if(this.loopNum >= this.toRotate.length-1) {
            var css = document.createElement("style");
            css.type = "text/css";
            css.innerHTML = ".typewrite > .wrap { border-right: 0em solid #fff}";
            document.body.appendChild(css);
        return;
      }
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
        }

        setTimeout(function() {
        that.tick();
        }, delta);
    };


    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite');
        for (var i=0; i<elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
             new TxtType(elements[i], JSON.parse(toRotate), period);
            } 
        }
        // INJECT CSS
        var css = document.createElement("style");
        css.type = "text/css";
        css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
        document.body.appendChild(css);
    };
